import { meetingBodyLink } from './links.js';
import { meetingJoinDimensions, meetingJoinTimeDimensions } from './shared-dimensions.js';
import { attendanceModeValueLabels, attendanceStatusValueLabels } from './value-labels.js';
/**
 * Combination data source: Roll Call Statuses x Members x Meetings.
 * One row per member per roll call: present, absent, or excused, and in person or remote.
 */
export const attendanceRecordsCube = {
    category: 'Meetings',
    description: 'Member attendance at every roll call: present, absent, or excused, and in person or remote.',
    label: 'Attendance Records',
    question: 'Who attended each meeting, and how?',
    bestFor: 'Roll call attendance per member and meeting, with excused absences and in-person versus remote participation.',
    tags: ['Attendance', 'Roll Call', 'Members'],
    requiredModule: 'hasRecord',
    measures: {
        'attendance_records.count': { label: 'Count', type: 'number' },
        'attendance_records.present_count': { label: 'Present', type: 'number' },
        'attendance_records.absent_count': { label: 'Absent', type: 'number' },
        'attendance_records.excused_count': { label: 'Excused', type: 'number' },
        'attendance_records.in_person_count': { label: 'In Person', type: 'number' },
        'attendance_records.remote_count': { label: 'Remote', type: 'number' },
    },
    dimensions: {
        // Attendance
        'attendance_records.status': {
            label: 'Attendance',
            type: 'string',
            valueLabels: attendanceStatusValueLabels,
        },
        'attendance_records.attendance_mode': {
            label: 'Attendance Mode',
            type: 'string',
            valueLabels: attendanceModeValueLabels,
        },
        'attendance_records.is_present': { label: 'Is Present', type: 'boolean' },
        'attendance_records.is_absence_excused': { label: 'Absence Excused', type: 'boolean' },
        'attendance_records.is_presence_physical': { label: 'Present In Person', type: 'boolean' },
        'attendance_records.notes': { label: 'Notes', narrative: true, type: 'string' },
        // Member
        'meeting_members.first_name': { label: 'Member First Name', type: 'string' },
        'meeting_members.last_name': { label: 'Member Last Name', type: 'string' },
        // Roll Call
        'roll_calls.is_recorded': { label: 'Roll Call Recorded', type: 'boolean' },
        // Meeting
        ...meetingJoinDimensions,
        'meeting_bodies.name': { label: 'Meeting Body', link: meetingBodyLink, type: 'string' },
    },
    timeDimensions: {
        ...meetingJoinTimeDimensions,
        'roll_calls.recorded_at': { label: 'Roll Call Recorded At', type: 'date' },
    },
};
